// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper___TBaO","schemaTable":"Table_schemaTable__BKOo9","body":"Table_body__tCnV1"};